/* ============================================================
   JUSTYOL REDESIGN — Product page JS
   Gallery / lightbox / variant sync / qty tiers / sticky bars /
   AJAX add-to-cart aligned with Hyper (FoxTheme) cart drawer.

   Add-to-cart mechanism (mirrors theme.js ProductForm):
   1. collect drawer section ids via 'cart:grouped-sections' document event
   2. POST FormData to FoxTheme.routes.cart_add_url
   3. fetch FoxTheme.routes.cart_url, attach parsedState.sections,
      publish FoxTheme.pubsub PUB_SUB_EVENTS.cartUpdate ({ cart })
   4. open drawer: document.querySelector('cart-drawer').show()
   COD CTA: dispatches document CustomEvent('jy:cod:open', { cancelable: true,
   detail: {...} }). The COD modal should call event.preventDefault() (or set
   window.JY_COD_LISTENING = true); otherwise the drawer opens as fallback.
   ============================================================ */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.jyInit) return;
    root.dataset.jyInit = '1';

    var isAr = root.hasAttribute('data-jy-ar');
    var parseJson = function (sel) {
      var el = root.querySelector(sel);
      if (!el) return null;
      try {
        return JSON.parse(el.textContent);
      } catch (e) {
        return null;
      }
    };

    var media = parseJson('[data-jy-media]') || [];
    var variants = parseJson('[data-jy-variants]') || [];
    var optionNames = parseJson('[data-jy-options]') || [];
    var productInfo = parseJson('[data-jy-product]') || {};

    /* NOTE: ViewContent + AddToCart are already fired by the official Meta/TikTok
       apps via Shopify Web Pixels (product_viewed / product_added_to_cart), so we
       do NOT fire them here — that would double-count. The theme only fires the
       COD funnel events the apps miss (InitiateCheckout/Purchase), server-side
       CAPI + a browser fallback deduped by event_id. */

    var form = root.querySelector('[data-jy-form]');
    var idInput = root.querySelector('[data-jy-id]');
    var qtyInput = root.querySelector('[data-jy-qty]');
    var tierProp = root.querySelector('[data-jy-tier-prop]');
    var errorEl = root.querySelector('[data-jy-error]');

    var fmt = function (cents) {
      var d = Math.round(cents / 100);
      return d.toLocaleString(isAr ? 'ar-MA' : 'fr-FR');
    };

    /* recently-viewed recording primarily lives in layout/theme.liquid (covers
       EVERY product template); this is a harmless idempotent fallback. */
    try {
      if (productInfo.handle) {
        var KEY = 'jy_recent';
        var list = [];
        try {
          list = JSON.parse(localStorage.getItem(KEY) || '[]');
        } catch (e) {}
        if (!Array.isArray(list)) list = [];
        list = list.filter(function (it) {
          return it && (typeof it === 'string' ? it : it.handle) !== productInfo.handle;
        });
        list.unshift({
          handle: productInfo.handle,
          title: productInfo.title,
          image: productInfo.image,
          price: productInfo.price,
          compare: productInfo.compare_at_price,
          vendor: productInfo.vendor,
          rating: typeof productInfo.rating === 'number' ? productInfo.rating : null,
          ratingCount: typeof productInfo.ratingCount === 'number' ? productInfo.ratingCount : null,
        });
        localStorage.setItem(KEY, JSON.stringify(list.slice(0, 12)));
      }
    } catch (e) {}

    /* ---------------- estimated delivery range (today+min → today+max) ----------------
       min/max come from the section settings (data-jy-eta-min/max) so the dates
       stay in sync with the "Livraison en X à Y jours" line. */
    var etaEl = root.querySelector('[data-jy-eta-range]');
    if (etaEl) {
      var etaMin = parseInt(root.getAttribute('data-jy-eta-min'), 10);
      var etaMax = parseInt(root.getAttribute('data-jy-eta-max'), 10);
      if (isNaN(etaMin)) etaMin = 2;
      if (isNaN(etaMax) || etaMax < etaMin) etaMax = etaMin + 2;
      var d1 = new Date();
      d1.setDate(d1.getDate() + etaMin);
      var d2 = new Date();
      d2.setDate(d2.getDate() + etaMax);
      var fmtDate = function (d) {
        try {
          return d.toLocaleDateString(isAr ? 'ar-MA' : 'fr-FR', { day: 'numeric', month: 'long' });
        } catch (e) {
          return d.getDate() + '/' + (d.getMonth() + 1);
        }
      };
      etaEl.textContent =
        (isAr ? 'التوصيل المتوقع: ' : 'Livraison estimée : ') + fmtDate(d1) + ' – ' + fmtDate(d2);
    }

    /* ---------------- gallery (desktop) ---------------- */
    var galMain = root.querySelector('[data-jy-gal-main]');
    var mainImg = root.querySelector('[data-jy-main-img]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-jy-thumb]'));
    var currentIndex = 0;

    /* ---- per-colour gallery filtering (SHEIN-style) ----
       Each media carries the colour it belongs to (server-side run-heuristic;
       '' = shared/shown for every colour). visibleIndices is the single source
       of truth for what the arrows, dots, count and lightbox cycle through, so
       picking a colour shows only that colour's angles. Falls back to showing
       everything whenever grouping is unreliable → never a regression. */
    var COLOR_OPT_NAMES = ['color', 'couleur', 'colour', 'اللون', 'لون'];
    var colorOptIdx = -1;
    optionNames.forEach(function (n, i) {
      if (COLOR_OPT_NAMES.indexOf(String(n).toLowerCase().trim()) >= 0) colorOptIdx = i;
    });
    var distinctColors = {};
    media.forEach(function (m) { if (m && m.color) distinctColors[m.color] = 1; });
    var colorFilterViable = colorOptIdx >= 0 && Object.keys(distinctColors).length >= 2;
    var visibleIndices = media.map(function (m, i) { return i; });
    function isVisibleIdx(i) { return visibleIndices.indexOf(i) >= 0; }

    /* lazily-created <video> that swaps in for video media (the payload used
       to carry only poster images, so desktop showed frozen frames) */
    var mainVideo = null;
    function ensureMainVideo() {
      if (mainVideo || !galMain) return mainVideo;
      mainVideo = document.createElement('video');
      mainVideo.className = 'jy-gal__video';
      mainVideo.muted = true;
      mainVideo.loop = true;
      mainVideo.autoplay = true;
      mainVideo.playsInline = true;
      mainVideo.setAttribute('playsinline', '');
      galMain.appendChild(mainVideo);
      return mainVideo;
    }
    /* Preload gallery images so desktop thumbnail clicks swap instantly.
       DESKTOP ONLY + idle: on mobile the rail lazy-loads its own 800px cells
       and media[i].src is the 1000px variant (shown nowhere on mobile), so
       eager-preloading all of them was ~1MB of pure waste racing the LCP. */
    if (window.matchMedia && window.matchMedia('(min-width: 768px)').matches) {
      var preloadAll = function () {
        media.forEach(function (m) {
          if (m && m.src && m.type !== 'video') {
            var im = new Image();
            im.src = m.src;
          }
        });
      };
      if (window.requestIdleCallback) requestIdleCallback(preloadAll, { timeout: 2500 });
      else setTimeout(preloadAll, 1500);
    }

    function setDesktopIndex(i) {
      if (!media[i]) return;
      currentIndex = i;
      var isVideo = media[i].type === 'video' && media[i].video;
      if (isVideo) {
        var v = ensureMainVideo();
        if (v) {
          if (v.src !== media[i].video) v.src = media[i].video;
          v.hidden = false;
          v.play().catch(function () {});
        }
        if (mainImg) mainImg.hidden = true;
      } else {
        if (mainVideo) {
          mainVideo.pause();
          mainVideo.hidden = true;
        }
        if (mainImg) {
          /* srcset carries the tiny-candidate LCP trick — drop it before
             swapping so the new src actually displays */
          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
          /* Desktop images are preloaded, so swap the src directly for an
             instant, clean change. The old fade dipped opacity to 0 first,
             exposing the white card underneath = an ugly white flash. */
          if (mainImg.src !== media[i].src) {
            mainImg.src = media[i].src;
          }
          mainImg.style.opacity = '';
          mainImg.hidden = false;
        }
      }
      if (galMain) galMain.dataset.index = String(i);
      thumbs.forEach(function (t, j) {
        var on = j === i;
        t.classList.toggle('on', on);
        if (on && t.scrollIntoView) t.scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: 'smooth' });
      });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        setDesktopIndex(parseInt(t.dataset.index, 10) || 0);
      });
    });

    /* main-image prev/next arrows (Trendyol-style) — wrap around */
    var galPrev = root.querySelector('[data-jy-gal-prev]');
    var galNext = root.querySelector('[data-jy-gal-next]');
    function galStep(delta) {
      if (!visibleIndices.length) return;
      var pos = visibleIndices.indexOf(currentIndex);
      if (pos < 0) pos = 0;
      pos = (pos + delta + visibleIndices.length) % visibleIndices.length;
      setDesktopIndex(visibleIndices[pos]);
    }
    if (galPrev) galPrev.addEventListener('click', function (e) { e.stopPropagation(); galStep(-1); });
    if (galNext) galNext.addEventListener('click', function (e) { e.stopPropagation(); galStep(1); });

    /* thumbnail carousel: prev/next arrows (shown only when the strip overflows) */
    var thumbStrip = root.querySelector('[data-jy-thumbs]');
    var thumbPrev = root.querySelector('[data-jy-thumbprev]');
    var thumbNext = root.querySelector('[data-jy-thumbnext]');
    function thumbStep(dir) {
      if (!thumbStrip) return;
      var rtl = document.documentElement.dir === 'rtl';
      thumbStrip.scrollBy({ left: Math.round(thumbStrip.clientWidth * 0.8) * dir * (rtl ? -1 : 1), behavior: 'smooth' });
    }
    if (thumbPrev) thumbPrev.addEventListener('click', function () { thumbStep(-1); });
    if (thumbNext) thumbNext.addEventListener('click', function () { thumbStep(1); });
    function refreshThumbNav() {
      if (!thumbStrip || !thumbPrev || !thumbNext) return;
      var overflow = thumbStrip.scrollWidth > thumbStrip.clientWidth + 4;
      thumbPrev.hidden = !overflow;
      thumbNext.hidden = !overflow;
    }
    if (thumbStrip) {
      refreshThumbNav();
      window.addEventListener('resize', refreshThumbNav, { passive: true });
      window.addEventListener('load', refreshThumbNav);
    }
    if (galMain) {
      galMain.addEventListener('click', function (e) {
        if (e.target.closest('.wishlist-btn')) return;
        openLightbox(currentIndex);
      });
    }

    /* ---------------- gallery (mobile swipe) ---------------- */
    var rail = root.querySelector('[data-jy-mgal-rail]');
    var mgalCount = root.querySelector('[data-jy-mgal-count]');
    var mgalDots = root.querySelector('[data-jy-mgal-dots]');
    var mgalDotsWin = root.querySelector('[data-jy-mgal-dotswin]');
    var mobIndex = 0;

    /* Windowed dots: once there are more visible dots than fit cleanly, slide the
       track so the active dot stays centred inside a fixed viewport (rather than
       rendering 35 unusable pinpricks). vp = active position among VISIBLE dots. */
    var DOT_PITCH = 12; /* 6px dot + 6px gap */
    var DOT_MAX = 7; /* window over ~7 dots before we start sliding */
    function layoutDots(vp) {
      if (!mgalDots || !mgalDotsWin) return;
      var n = visibleIndices.length;
      var windowed = n > DOT_MAX;
      mgalDotsWin.classList.toggle('is-windowed', windowed);
      if (!windowed) {
        mgalDots.style.transform = '';
        return;
      }
      /* centre the active dot in the ~84px viewport, clamped to the ends */
      var winPx = 84;
      var trackPx = n * DOT_PITCH;
      var shift = winPx / 2 - (vp * DOT_PITCH + DOT_PITCH / 2);
      var minShift = winPx - trackPx; /* last dot flush right */
      if (shift > 0) shift = 0;
      if (shift < minShift) shift = minShift;
      mgalDots.style.transform = 'translateX(' + shift + 'px)';
    }

    /* warm the neighbouring rail cells so swiping never lands on a blank white
       (lazy) cell — the source of the "flash" between mobile images */
    function warmMobileNeighbors(i) {
      if (!rail) return;
      [i - 1, i, i + 1, i + 2].forEach(function (idx) {
        var cell = rail.querySelector('.jy-mgal__cell[data-index="' + idx + '"]');
        if (!cell) return;
        var img = cell.querySelector('img');
        if (img && !img.complete && img.getAttribute('src')) {
          img.loading = 'eager';
          var warm = new Image();
          warm.src = img.currentSrc || img.src;
        }
      });
    }

    function setMobileUi(i) {
      mobIndex = i;
      var vp = visibleIndices.indexOf(i);
      if (vp < 0) vp = 0;
      if (mgalCount) mgalCount.textContent = vp + 1 + '/' + visibleIndices.length;
      if (mgalDots) {
        /* dots are indexed by absolute media index; hidden ones collapse so the
           visible run reads 1..N for the current colour */
        Array.prototype.forEach.call(mgalDots.children, function (d, j) {
          d.classList.toggle('on', j === i);
        });
        layoutDots(vp);
      }
      warmMobileNeighbors(i);
    }
    if (rail) {
      rail.addEventListener(
        'scroll',
        function () {
          var w = rail.clientWidth || 1;
          /* hidden cells collapse, so scroll position maps to a VISIBLE position
             — translate it back to the absolute media index */
          var vp = Math.round(Math.abs(rail.scrollLeft) / w);
          vp = Math.max(0, Math.min(visibleIndices.length - 1, vp));
          var i = visibleIndices[vp];
          if (i !== mobIndex) setMobileUi(i);
        },
        { passive: true }
      );
      rail.addEventListener('click', function (e) {
        var cell = e.target.closest('.jy-mgal__cell');
        /* video cells play inline; only image cells open the lightbox */
        if (cell && !cell.classList.contains('jy-mgal__cell--video')) {
          openLightbox(parseInt(cell.dataset.index, 10) || 0);
        }
      });

      /* play gallery videos only while visible (battery/data friendly) */
      if ('IntersectionObserver' in window) {
        var vidIo = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              var v = entry.target;
              if (entry.isIntersecting && entry.intersectionRatio > 0.5) {
                var p = v.play();
                if (p && p.catch) p.catch(function () {});
              } else {
                v.pause();
              }
            });
          },
          { threshold: [0, 0.6] }
        );
        rail.querySelectorAll('video').forEach(function (v) {
          v.muted = true;
          vidIo.observe(v);
        });
      }
    }
    function scrollMobileTo(i) {
      if (!rail) return;
      var vp = visibleIndices.indexOf(i);
      if (vp < 0) vp = 0;
      var dir = document.documentElement.dir === 'rtl' ? -1 : 1;
      rail.scrollTo({ left: dir * rail.clientWidth * vp, behavior: 'smooth' });
    }

    /* Show only the selected colour's media across desktop thumbs, the mobile
       rail and the dots; rebuild visibleIndices so all nav stays in sync. */
    function filterGalleryByColor(colorValue) {
      if (!colorFilterViable) return;
      var hasOwn = media.some(function (m) { return m && m.color === colorValue; });
      var matched;
      if (!hasOwn) {
        /* colour has no dedicated media → don't hide anything (safety) */
        matched = media.map(function (m, i) { return i; });
      } else {
        matched = [];
        media.forEach(function (m, i) {
          var c = m && m.color;
          if (!c || c === colorValue) matched.push(i); /* '' = shared */
        });
      }
      if (!matched.length) matched = media.map(function (m, i) { return i; });
      visibleIndices = matched;
      var vis = {};
      matched.forEach(function (i) { vis[i] = 1; });
      thumbs.forEach(function (t) {
        var idx = parseInt(t.dataset.index, 10);
        t.hidden = !vis[idx];
      });
      if (rail) {
        Array.prototype.forEach.call(rail.children, function (cell) {
          var idx = parseInt(cell.dataset.index, 10);
          if (!isNaN(idx)) cell.hidden = !vis[idx];
        });
      }
      if (mgalDots) {
        Array.prototype.forEach.call(mgalDots.children, function (d, j) {
          d.hidden = !vis[j];
        });
      }
      /* visible count changed → re-window the dots for the current position */
      var curVp = visibleIndices.indexOf(mobIndex);
      layoutDots(curVp < 0 ? 0 : curVp);
      refreshThumbNav();
    }

    root.querySelectorAll('button[data-jy-open-lbx]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        openLightbox(window.innerWidth <= 767 ? mobIndex : currentIndex);
      });
    });

    /* ---------------- lightbox ---------------- */
    var lbx = root.querySelector('[data-jy-lbx]');
    var lbxImg = root.querySelector('[data-jy-lbx-img]');
    var lbxStage = root.querySelector('[data-jy-lbx-stage]');
    var lbxCount = root.querySelector('[data-jy-lbx-count]');
    var lbxHint = root.querySelector('[data-jy-lbx-hint]');
    var lbxIndex = 0;
    /* the image's UNSCALED box, captured at zoom-in — transform-origin must be
       computed against the image itself (it's pillar-boxed inside the wider
       stage on desktop), not the stage, or the zoom jumps into the letterbox */
    var lbxImgBox = null;

    var lbxVideo = null;
    function ensureLbxVideo() {
      if (lbxVideo || !lbxStage) return lbxVideo;
      lbxVideo = document.createElement('video');
      lbxVideo.className = 'jy-lbx__video';
      lbxVideo.muted = true;
      lbxVideo.loop = true;
      lbxVideo.autoplay = true;
      lbxVideo.playsInline = true;
      lbxVideo.setAttribute('playsinline', '');
      lbxVideo.controls = true;
      lbxStage.appendChild(lbxVideo);
      return lbxVideo;
    }
    function lbxSet(i) {
      if (!media.length) return;
      /* clamp to a visible media index (colour filter may hide some) */
      if (!isVisibleIdx(i)) i = visibleIndices.length ? visibleIndices[0] : 0;
      lbxIndex = i;
      var m = media[lbxIndex];
      var isVideo = m.type === 'video' && m.video;
      if (isVideo) {
        var v = ensureLbxVideo();
        if (v) {
          if (v.src !== m.video) v.src = m.video;
          v.hidden = false;
          v.play().catch(function () {});
        }
        if (lbxImg) lbxImg.hidden = true;
        if (lbxHint) lbxHint.textContent = '';
      } else {
        if (lbxVideo) {
          lbxVideo.pause();
          lbxVideo.hidden = true;
        }
        if (lbxImg) {
          lbxImg.src = m.full;
          lbxImg.style.transformOrigin = '50% 50%';
          lbxImg.hidden = false;
        }
        if (lbxHint) lbxHint.textContent = isAr ? 'اضغط للتكبير' : 'Cliquez pour zoomer';
      }
      if (lbxStage) lbxStage.classList.remove('zoomed');
      lbxImgBox = null;
      if (lbxImg) lbxImg.style.transformOrigin = '50% 50%';
      if (lbxCount) {
        var vp = visibleIndices.indexOf(lbxIndex);
        lbxCount.textContent = (vp < 0 ? 0 : vp) + 1 + ' / ' + visibleIndices.length;
      }
    }
    /* step through the visible media only */
    function lbxStep(delta) {
      if (!visibleIndices.length) return;
      var pos = visibleIndices.indexOf(lbxIndex);
      if (pos < 0) pos = 0;
      pos = (pos + delta + visibleIndices.length) % visibleIndices.length;
      lbxSet(visibleIndices[pos]);
    }
    var lbxReturnFocus = null;
    function openLightbox(i) {
      if (!lbx || !media.length) return;
      lbxSet(i || 0);
      lbx.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      /* aria-modal without focus management leaves keyboard users behind
         the overlay — move focus in, restore it on close */
      lbxReturnFocus = document.activeElement;
      var cb = lbx.querySelector('[data-jy-lbx-close]');
      if (cb) cb.focus();
    }
    function closeLightbox() {
      if (!lbx) return;
      if (lbxVideo) lbxVideo.pause();
      lbx.hidden = true;
      document.documentElement.style.overflow = '';
      if (lbxReturnFocus && lbxReturnFocus.focus) lbxReturnFocus.focus();
      lbxReturnFocus = null;
    }
    if (lbx) {
      lbx.addEventListener('click', function (e) {
        if (e.target === lbx) closeLightbox();
      });
      var closeBtn = root.querySelector('[data-jy-lbx-close]');
      closeBtn && closeBtn.addEventListener('click', closeLightbox);
      var prevBtn = root.querySelector('[data-jy-lbx-prev]');
      var nextBtn = root.querySelector('[data-jy-lbx-next]');
      var rtl = document.documentElement.dir === 'rtl';
      prevBtn &&
        prevBtn.addEventListener('click', function () {
          lbxStep(rtl ? 1 : -1);
        });
      nextBtn &&
        nextBtn.addEventListener('click', function () {
          lbxStep(rtl ? -1 : 1);
        });
      document.addEventListener('keydown', function (e) {
        if (lbx.hidden) return;
        if (e.key === 'Escape') closeLightbox();
        if (e.key === 'ArrowLeft') lbxStep(-1);
        if (e.key === 'ArrowRight') lbxStep(1);
        if (e.key === 'Tab') {
          /* keep Tab inside the dialog */
          var f = lbx.querySelectorAll('button, video, [href]');
          if (!f.length) return;
          var first = f[0];
          var last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      });
      if (lbxStage) {
        /* map a client point to a 0–100% origin WITHIN the image box (clamped),
           so edges are reachable and clicks in the letterbox don't zoom to black */
        function originFrom(e) {
          var box = lbxImgBox || (lbxImg && lbxImg.getBoundingClientRect());
          if (!box || !box.width || !box.height) return null;
          var x = Math.max(0, Math.min(100, ((e.clientX - box.left) / box.width) * 100));
          var y = Math.max(0, Math.min(100, ((e.clientY - box.top) / box.height) * 100));
          return x + '% ' + y + '%';
        }
        /* click-to-zoom 2.4x at cursor */
        lbxStage.addEventListener('click', function (e) {
          if (!lbxImg || lbxImg.hidden) return; // videos aren't zoomable
          var willZoom = !lbxStage.classList.contains('zoomed');
          if (willZoom) lbxImgBox = lbxImg.getBoundingClientRect(); // capture UNSCALED box
          var origin = originFrom(e);
          if (origin) lbxImg.style.transformOrigin = origin;
          var zoomed = lbxStage.classList.toggle('zoomed');
          if (!zoomed) lbxImgBox = null;
          if (lbxHint) {
            lbxHint.textContent = zoomed
              ? isAr
                ? 'اضغط للتصغير'
                : 'Cliquez pour réduire'
              : isAr
                ? 'اضغط للتكبير'
                : 'Cliquez pour zoomer';
          }
        });
        lbxStage.addEventListener('pointermove', function (e) {
          if (!lbxStage.classList.contains('zoomed') || !lbxImg) return;
          /* mouse: hover-pan; touch: finger-drag pans (was mouse-only, so
             phones could zoom but never move around the image) */
          if ((e.pointerType === 'mouse' && e.buttons === 0) || e.pointerType !== 'mouse') {
            var origin = originFrom(e);
            if (origin) lbxImg.style.transformOrigin = origin;
          }
        });
      }
    }

    /* ---------------- variant selection ---------------- */
    var selected = [];
    (function () {
      var curId = idInput ? parseInt(idInput.value, 10) : 0;
      var cur =
        variants.filter(function (v) {
          return v.id === curId;
        })[0] || variants[0];
      if (cur) selected = (cur.options || []).slice();
    })();

    function findVariant() {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var j = 0; j < selected.length; j++) {
          if ((v.options || [])[j] !== selected[j]) {
            ok = false;
            break;
          }
        }
        if (ok) return v;
      }
      return null;
    }

    function mediaIndexById(id) {
      for (var i = 0; i < media.length; i++) {
        if (String(media[i].id) === String(id)) return i;
      }
      return -1;
    }

    /* variants|json exposes featured_image (and sometimes featured_media) */
    function variantMediaIndex(v) {
      var fm = (v && (v.featured_media || v.featured_image)) || null;
      if (!fm) return -1;
      var mi = mediaIndexById(fm.id);
      if (mi < 0 && fm.position) mi = fm.position - 1;
      return mi >= 0 && mi < media.length ? mi : -1;
    }

    var tierState = 1;

    function updatePrices(v) {
      if (!v) return;
      var price = v.price;
      var compare = v.compare_at_price || 0;
      var onSale = compare > price;

      root.querySelectorAll('[data-jy-price], [data-jy-bb-price]').forEach(function (el) {
        el.textContent = fmt(price);
      });
      root.querySelectorAll('[data-jy-was], [data-jy-bb-was]').forEach(function (el) {
        el.hidden = !onSale;
        if (onSale) el.textContent = fmt(compare) + ' ' + (productInfo.currency || 'Dhs');
      });
      var offEl = root.querySelector('[data-jy-off]');
      var pct = onSale ? Math.round(((compare - price) * 100) / compare) : 0;
      if (offEl) {
        offEl.hidden = !onSale;
        offEl.textContent = '-' + pct + '%';
      }
      root.querySelectorAll('[data-jy-pct-badge]').forEach(function (el) {
        el.hidden = !onSale;
        el.textContent = '-' + pct + '%';
      });
      var saveAmt = root.querySelector('[data-jy-save-amt]');
      if (saveAmt) {
        saveAmt.hidden = !onSale;
        if (onSale) {
          saveAmt.textContent =
            (isAr ? 'وفّر ' : 'Économisez ') + fmt(compare - price) + ' ' + (productInfo.currency || 'Dhs');
        }
      }

      /* qty tier totals: x1, x1.8, x2.55 (display only — see section comment) */
      var totals = { 1: price, 2: Math.round(price * 1.8), 3: Math.round(price * 2.7) };
      [1, 2, 3].forEach(function (n) {
        var tEl = root.querySelector('[data-jy-tier-total="' + n + '"]');
        if (tEl) tEl.textContent = fmt(totals[n]);
        var uEl = root.querySelector('[data-jy-tier-unit="' + n + '"]');
        if (uEl) uEl.textContent = fmt(Math.round(totals[n] / n));
        if (n > 1) {
          var sEl = root.querySelector('[data-jy-tier-save="' + n + '"]');
          if (sEl) sEl.textContent = fmt(price * n - totals[n]);
        }
      });
    }

    /* stock urgency bar — re-evaluated per variant when inventory data is exposed */
    var stockbar = root.querySelector('[data-jy-stockbar]');
    function updateStockbar(v) {
      if (!stockbar || !v) return;
      if (typeof v.inventory_quantity !== 'number' || !v.inventory_management) return;
      var threshold = parseInt(stockbar.dataset.threshold, 10) || 9;
      var q = v.inventory_quantity;
      var low = !!v.available && q > 0 && q <= threshold;
      stockbar.hidden = !low;
      if (!low) return;
      var fill = stockbar.querySelector('[data-jy-stockbar-fill]');
      if (fill) fill.style.width = Math.min(90, Math.max(8, 100 - q * 9)) + '%';
      var lbl = stockbar.querySelector('[data-jy-stockbar-label]');
      if (lbl) lbl.textContent = isAr ? 'بقيت ' + q + ' قطع فقط!' : 'Plus que ' + q + ' en stock !';
    }

    function updateAvailability(v) {
      var available = !!(v && v.available);
      root.querySelectorAll('[data-jy-cta]').forEach(function (btn) {
        btn.disabled = !available;
      });
      var codLabel = root.querySelector('[data-jy-cod-label]');
      if (codLabel && !available) codLabel.textContent = isAr ? 'نفد المخزون' : 'Épuisé';
    }

    /* ---- WhatsApp order message (Zoko-style), synced to the variant ---- */
    function waDigits() {
      var n = (window.JY_WA || '') + '';
      return n.replace(/[^0-9]/g, '');
    }
    function buildWaText(v) {
      var cur = productInfo.currency || 'Dhs';
      var url = location.origin + (productInfo.url || '') + (v ? '?variant=' + v.id : '');
      var head = isAr ? '🛍️ *طلب جديد — Justyol*' : '🛍️ *Nouvelle commande — Justyol*';
      var skuLabel = isAr ? '🔖 المرجع: ' : '🔖 Réf: ';
      var lines = [head, '', '📦 ' + (productInfo.title || '')];
      var vt = v && v.title && v.title !== 'Default Title' ? v.title : '';
      if (vt) lines.push('🎚️ ' + vt);
      if (v && v.sku) lines.push(skuLabel + v.sku);
      lines.push('💰 ' + (v ? fmt(v.price) : '') + ' ' + cur);
      lines.push('🔗 ' + url);
      return lines.join('\n');
    }
    function updateWhatsApp(v) {
      var num = waDigits();
      if (!num) return;
      var href = 'https://wa.me/' + num + '?text=' + encodeURIComponent(buildWaText(v));
      root.querySelectorAll('[data-jy-wa]').forEach(function (a) {
        a.href = href;
      });
    }

    function applyVariant(v) {
      if (!v) {
        updateAvailability(null);
        return;
      }
      if (idInput) idInput.value = v.id;
      updatePrices(v);
      updateWhatsApp(v);
      /* keep the displayed SKU/reference in sync with the variant */
      var skuWrap = root.querySelector('[data-jy-sku-wrap]');
      var skuEl = root.querySelector('[data-jy-sku]');
      if (skuWrap && skuEl) {
        if (v.sku) {
          skuEl.textContent = v.sku;
          skuWrap.hidden = false;
        } else {
          skuWrap.hidden = true;
        }
      }
      updateAvailability(v);
      updateStockbar(v);
      /* filter the gallery to the selected colour, then sync to its image.
         Guarded so a gallery hiccup never blocks price/stock/CTA updates. */
      try {
        if (colorFilterViable && colorOptIdx >= 0) {
          filterGalleryByColor((v.options || [])[colorOptIdx]);
        }
        var mi = variantMediaIndex(v);
        if (mi >= 0) {
          setDesktopIndex(mi);
          scrollMobileTo(mi);
        }
      } catch (e) {
        if (typeof console !== 'undefined') console.warn('jy gallery sync', e);
      }
      /* current value labels — "· n/total", per design */
      root.querySelectorAll('[data-jy-opt-current]').forEach(function (el) {
        var oi = parseInt(el.getAttribute('data-jy-opt-current'), 10);
        var row = root.querySelector('[data-jy-option="' + oi + '"] .jy-opt__row');
        if (!row) return;
        var btns = row.querySelectorAll('[data-jy-opt-val]');
        var pos = 0;
        btns.forEach(function (b, k) {
          if (b.classList.contains('on')) pos = k + 1;
        });
        if (pos) {
          el.innerHTML = '';
          var span = document.createElement('span');
          span.className = 'jy-ltr';
          span.textContent = '· ' + pos + '/' + btns.length;
          el.appendChild(span);
        }
      });
      /* keep URL shareable */
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
    }

    /* sort size buttons: numeric sizes ascending (34,36,38…), letter sizes
       XS→XXXL — Shopify keeps them in variant-creation order (e.g. …42,34,44) */
    (function sortSizes() {
      var LETTER = ['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl', 'xxxl', '2xl', '3xl', '4xl', '5xl'];
      root.querySelectorAll('.jy-opt__row').forEach(function (row) {
        var btns = Array.prototype.slice.call(row.querySelectorAll('.jy-opt__size'));
        if (btns.length < 2) return;
        function rank(btn) {
          var v = (btn.getAttribute('data-value') || '').trim();
          var num = parseFloat(v.replace(',', '.'));
          if (!isNaN(num) && /^[\d.,\s]+$/.test(v)) return num; // pure numeric
          var li = LETTER.indexOf(v.toLowerCase());
          return li === -1 ? 9999 : 1000 + li; // letters after numbers, unknown last
        }
        var sorted = btns.slice().sort(function (a, b) {
          return rank(a) - rank(b);
        });
        var changed = sorted.some(function (b, i) {
          return b !== btns[i];
        });
        if (changed) {
          sorted.forEach(function (b) {
            row.appendChild(b);
          });
        }
      });
    })();

    /* initial sync: highlight the right thumb for ?variant= deep links */
    (function () {
      var v = findVariant();
      /* Gallery init is wrapped so a data edge-case (unusual media/colour setup)
         can never throw and abort the rest of this section script — that would
         leave add-to-cart & the whole PDP unbound ("dead" page). */
      try {
        /* apply the colour filter for the initially-selected variant on load */
        if (colorFilterViable && v && colorOptIdx >= 0) {
          filterGalleryByColor((v.options || [])[colorOptIdx]);
          /* rail sits at scroll 0 → first visible cell; align dots/count to it */
          if (visibleIndices.length) setMobileUi(visibleIndices[0]);
        }
        /* window the dots on load too, so a 35-image product never flashes the
           full smear of dots before the first swipe */
        layoutDots(0);
        warmMobileNeighbors(0);
      } catch (e) {
        /* gallery enhancement failed → fall back to showing everything */
        if (typeof console !== 'undefined') console.warn('jy gallery init', e);
      }
      var mi = variantMediaIndex(v);
      if (mi > 0) setDesktopIndex(mi);
      updateWhatsApp(v);
      /* out-of-stock values are hidden server-side, so the "· n/total" counter
         must count the visible buttons, not the Liquid-rendered total */
      root.querySelectorAll('[data-jy-opt-current]').forEach(function (el) {
        var oi = parseInt(el.getAttribute('data-jy-opt-current'), 10);
        var row = root.querySelector('[data-jy-option="' + oi + '"] .jy-opt__row');
        if (!row) return;
        var btns = row.querySelectorAll('[data-jy-opt-val]');
        var pos = 0;
        btns.forEach(function (b, k) {
          if (b.classList.contains('on')) pos = k + 1;
        });
        if (pos) {
          el.innerHTML = '<span class="jy-ltr">· ' + pos + '/' + btns.length + '</span>';
        }
      });
    })();

    /* strike through option values that are sold out (or don't exist) given
       the other selected options — the .oos style existed but nothing ever
       applied it, so shoppers picked dead sizes with zero cue */
    function updateOptionAvailability() {
      root.querySelectorAll('[data-jy-opt-val]').forEach(function (btn) {
        var oi = parseInt(btn.dataset.opt, 10);
        var val = btn.dataset.value;
        var sellable = false;
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var opts = v.options || [];
          if (opts[oi] !== val) continue;
          var matches = true;
          for (var j = 0; j < selected.length; j++) {
            if (j !== oi && selected[j] != null && opts[j] !== selected[j]) {
              matches = false;
              break;
            }
          }
          if (matches && v.available) {
            sellable = true;
            break;
          }
        }
        btn.classList.toggle('oos', !sellable);
      });
    }
    updateOptionAvailability();

    root.querySelectorAll('[data-jy-opt-val]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var oi = parseInt(btn.dataset.opt, 10);
        selected[oi] = btn.dataset.value;
        var row = btn.closest('.jy-opt__row');
        if (row) {
          row.querySelectorAll('[data-jy-opt-val]').forEach(function (b) {
            b.classList.toggle('on', b === btn);
          });
        }
        updateOptionAvailability();
        applyVariant(findVariant());
      });
    });

    /* ---------------- qty tiers ---------------- */
    /* a product is "pickable" when the shopper can mix variants (SHEIN/Temu
       multi-buy). Single-variant products keep the plain quantity behaviour. */
    var VARIETY =
      variants.length > 1 &&
      optionNames.length > 0 &&
      !(variants.length === 1 && variants[0] && variants[0].title === 'Default Title');

    function setTierUI(n) {
      tierState = n;
      root.querySelectorAll('[data-jy-tier]').forEach(function (b) {
        var on = parseInt(b.dataset.jyTier, 10) === n;
        b.classList.toggle('on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (qtyInput) qtyInput.value = n;
      if (tierProp) {
        if (n > 1) {
          tierProp.disabled = false;
          tierProp.value = 't' + n;
        } else {
          tierProp.disabled = true;
          tierProp.value = '';
        }
      }
    }

    /* window.JY_BUNDLE carries the shopper's per-piece variant picks to the
       add-to-cart + COD express flows (each piece = its own line, qty 1).
       Cleared when the shopper is back on a single piece. */
    function setBundle(pieces) {
      if (pieces && pieces.length > 1) {
        /* aggregate identical picks so 2× the same variant adds as qty 2 */
        var agg = {};
        pieces.forEach(function (id) {
          agg[id] = (agg[id] || 0) + 1;
        });
        window.JY_BUNDLE = {
          productId: productInfo.id,
          pieces: Object.keys(agg).map(function (id) {
            return { id: parseInt(id, 10), quantity: agg[id] };
          }),
          tier: pieces.length,
        };
      } else {
        window.JY_BUNDLE = null;
      }
    }

    root.querySelectorAll('[data-jy-tier]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var n = parseInt(btn.dataset.jyTier, 10) || 1;
        setTierUI(n);
        if (n > 1 && VARIETY) {
          openPicker(n);
        } else {
          setBundle(null);
          updatePickedSummary(null);
        }
      });
    });

    /* ---------------- multi-piece variant picker ---------------- */
    var pp = document.querySelector('[data-jy-pp]');

    function optionValues(oi) {
      var seen = {};
      var out = [];
      variants.forEach(function (v) {
        var val = (v.options || [])[oi];
        if (val != null && !seen[val]) {
          seen[val] = 1;
          out.push(val);
        }
      });
      return out;
    }
    var SIZE_WORDS = ['size', 'sizes', 'taille', 'tailles', 'pointure', 'مقاس', 'المقاس', 'الحجم'];
    function isSizeOption(oi) {
      var n = (optionNames[oi] || '').toLowerCase().trim();
      return SIZE_WORDS.indexOf(n) !== -1;
    }
    /* representative variant image for an option value (same as the PDP swatch) */
    function optionImage(oi, val) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if ((v.options || [])[oi] === val && v.featured_image && v.featured_image.src) {
          return v.featured_image.src;
        }
      }
      return productInfo.image || '';
    }
    /* does this product actually carry per-variant images worth showing? */
    var HAS_VARIANT_IMAGES = variants.some(function (v) {
      return v.featured_image && v.featured_image.src;
    });
    function resolveVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var vo = variants[i].options || [];
        var ok = true;
        for (var j = 0; j < optionNames.length; j++) {
          if (opts[j] == null || vo[j] !== opts[j]) {
            ok = false;
            break;
          }
        }
        if (ok) return variants[i];
      }
      return null;
    }
    function comboAvailable(opts, oi, val) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var vo = v.options || [];
        if (vo[oi] !== val) continue;
        var ok = true;
        for (var j = 0; j < optionNames.length; j++) {
          if (j !== oi && opts[j] != null && vo[j] !== opts[j]) {
            ok = false;
            break;
          }
        }
        if (ok && v.available) return true;
      }
      return false;
    }

    var pieceState = []; /* array of opts-arrays, one per piece */

    function pickerConfirmable() {
      for (var i = 0; i < pieceState.length; i++) {
        var v = resolveVariant(pieceState[i]);
        if (!v || !v.available) return false;
      }
      return true;
    }
    function pickerTotalCents() {
      var sum = 0;
      pieceState.forEach(function (opts) {
        var v = resolveVariant(opts);
        if (v) sum += v.price;
      });
      return sum;
    }
    function renderPicker() {
      if (!pp) return;
      var wrap = pp.querySelector('[data-jy-pp-pieces]');
      var titleEl = pp.querySelector('[data-jy-pp-title]');
      var subEl = pp.querySelector('[data-jy-pp-sub]');
      var totalEl = pp.querySelector('[data-jy-pp-total]');
      var confirmBtn = pp.querySelector('[data-jy-pp-confirm]');
      var n = pieceState.length;
      if (titleEl) titleEl.textContent = isAr ? 'اختر ' + n + ' قطع' : 'Choisissez vos ' + n + ' articles';
      if (subEl)
        subEl.textContent = isAr
          ? 'لون ومقاس مختلف لكل قطعة — نفس السعر'
          : 'Couleur et taille au choix pour chaque article — même prix';

      wrap.innerHTML = '';
      pieceState.forEach(function (opts, pi) {
        var v = resolveVariant(opts);
        var card = document.createElement('div');
        card.className = 'jy-pp__piece';

        var head = document.createElement('div');
        head.className = 'jy-pp__piece-head';
        var thumb = document.createElement('span');
        thumb.className = 'jy-pp__thumb';
        var imgUrl = (v && (v.featured_image && v.featured_image.src)) || productInfo.image || '';
        if (imgUrl) thumb.style.backgroundImage = 'url(' + imgUrl + ')';
        head.appendChild(thumb);
        var htxt = document.createElement('span');
        htxt.className = 'jy-pp__piece-title';
        htxt.textContent =
          (isAr ? 'القطعة ' : 'Article ') + (pi + 1) + (pi === 0 ? (isAr ? ' (اختيارك)' : ' (votre choix)') : '');
        head.appendChild(htxt);
        card.appendChild(head);

        optionNames.forEach(function (oname, oi) {
          var asImage = !isSizeOption(oi) && HAS_VARIANT_IMAGES;
          var orow = document.createElement('div');
          orow.className = 'jy-pp__orow' + (asImage ? ' jy-pp__orow--img' : '');

          var lbl = document.createElement('span');
          lbl.className = 'jy-pp__olabel';
          lbl.textContent = oname;
          /* echo the chosen value next to the label (Color · Beige) */
          if (opts[oi] != null) {
            var chosen = document.createElement('span');
            chosen.className = 'jy-pp__ochosen';
            chosen.textContent = opts[oi];
            lbl.appendChild(chosen);
          }
          orow.appendChild(lbl);

          var vals = document.createElement('div');
          vals.className = 'jy-pp__ovals' + (asImage ? ' jy-pp__ovals--img' : '');
          optionValues(oi).forEach(function (val) {
            var b = document.createElement('button');
            b.type = 'button';
            if (opts[oi] === val) b.classList.add('on');
            if (!comboAvailable(opts, oi, val)) b.classList.add('oos');
            if (asImage) {
              b.className += ' jy-pp__oval jy-pp__oval--img';
              b.title = val;
              b.setAttribute('aria-label', val);
              var im = document.createElement('img');
              /* Shopify CDN size suffix goes before the extension: file_120x.jpg */
              im.src = optionImage(oi, val).replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2');
              im.loading = 'lazy';
              im.alt = val;
              b.appendChild(im);
              var chk = document.createElement('span');
              chk.className = 'jy-pp__ovcheck';
              chk.innerHTML =
                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
              b.appendChild(chk);
            } else {
              b.className += ' jy-pp__oval';
              b.textContent = val;
            }
            b.addEventListener('click', function () {
              opts[oi] = val;
              /* if the new combo is impossible, clear the other options so the
                 shopper re-picks a valid pair */
              if (!resolveVariant(opts)) {
                for (var k = 0; k < optionNames.length; k++) {
                  if (k !== oi && !comboAvailable(opts, k, opts[k])) opts[k] = null;
                }
              }
              renderPicker();
            });
            vals.appendChild(b);
          });
          orow.appendChild(vals);
          card.appendChild(orow);
        });
        wrap.appendChild(card);
      });

      if (totalEl) totalEl.textContent = fmt(pickerTotalCents()) + ' ' + (productInfo.currency || 'Dhs');
      if (confirmBtn) confirmBtn.disabled = !pickerConfirmable();
    }

    function openPicker(n) {
      if (!pp) {
        setBundle(null);
        return;
      }
      /* not confirmed yet → no stale bundle; cancelling falls back to qty×N */
      setBundle(null);
      updatePickedSummary(null);
      pieceState = [];
      var base = (selected || []).slice();
      for (var i = 0; i < n; i++) pieceState.push(base.slice());
      renderPicker();
      pp.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    }
    function closePicker() {
      if (!pp) return;
      pp.hidden = true;
      document.documentElement.style.overflow = '';
    }

    function updatePickedSummary(pieces) {
      var box = root.querySelector('[data-jy-picked]');
      if (!box) return;
      if (!pieces || pieces.length < 2) {
        box.hidden = true;
        box.innerHTML = '';
        return;
      }
      box.hidden = false;
      var html = '<span class="jy-picked__lbl">' + (isAr ? 'اخترت:' : 'Sélection :') + '</span>';
      pieces.forEach(function (id) {
        var v = variants.filter(function (x) {
          return x.id === id;
        })[0];
        if (!v) return;
        var t = v.title && v.title !== 'Default Title' ? v.title : '';
        html += '<span class="jy-picked__chip">' + (t || '') + '</span>';
      });
      html +=
        ' <button type="button" class="jy-picked__edit" data-jy-picked-edit>' +
        (isAr ? 'تعديل' : 'Modifier') +
        '</button>';
      box.innerHTML = html;
    }

    if (pp) {
      pp.addEventListener('click', function (e) {
        if (e.target.closest('[data-jy-pp-close]')) {
          closePicker();
          return;
        }
        if (e.target.closest('[data-jy-pp-confirm]')) {
          if (!pickerConfirmable()) return;
          var pieces = pieceState.map(function (opts) {
            return resolveVariant(opts).id;
          });
          setBundle(pieces);
          updatePickedSummary(pieces);
          closePicker();
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !pp.hidden) closePicker();
      });
    }
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-jy-picked-edit]')) openPicker(tierState);
    });

    /* ---------------- size guide link -> accordion ---------------- */
    root.querySelectorAll('[data-jy-sizeguide]').forEach(function (link) {
      link.addEventListener('click', function () {
        var acc = root.querySelector('[data-jy-sizeguide-acc]');
        if (!acc) return;
        acc.open = true;
        acc.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });

    /* ---------------- add to cart (Hyper-aligned AJAX) ---------------- */
    function setLoading(btn, on) {
      if (!btn) return;
      btn.classList.toggle('jy-loading', on);
      btn.setAttribute('aria-disabled', on ? 'true' : 'false');
    }

    function showError(msg) {
      if (!errorEl) return;
      errorEl.hidden = !msg;
      if (msg) errorEl.textContent = msg;
    }

    function cartDrawer() {
      return document.querySelector('cart-drawer');
    }

    /* Add-to-cart confirmation toast (SHEIN-style: product thumb + title +
       'View cart' CTA). No drawer — user keeps browsing; badge pulses. */
    var toastTimer = null;
    function pulseCartBadge() {
      document.querySelectorAll('.jy-cnt').forEach(function (b) {
        b.classList.remove('jy-cnt--bump');
        void b.offsetWidth;
        b.classList.add('jy-cnt--bump');
      });
    }
    function jyToast(info) {
      info = info || {};
      var cartUrl = ((window.FoxTheme && FoxTheme.routes && FoxTheme.routes.cart_url) || '/cart');
      var el = document.getElementById('jy-atc-toast');
      if (!el) {
        el = document.createElement('div');
        el.id = 'jy-atc-toast';
        el.className = 'jy-atc-toast';
        el.setAttribute('role', 'status');
        document.body.appendChild(el);
      }
      var img = info.image
        ? '<img class="jy-atc-toast__img" src="' + info.image + '" alt="" width="46" height="46" loading="lazy">'
        : '<span class="jy-atc-toast__ico" aria-hidden="true">✓</span>';
      var title = info.title
        ? '<span class="jy-atc-toast__name">' + info.title + '</span>'
        : '';
      el.innerHTML =
        img +
        '<span class="jy-atc-toast__body">' +
        '<span class="jy-atc-toast__ok">' +
        (isAr ? '✓ أُضيف إلى السلة' : '✓ Ajouté au panier') +
        '</span>' +
        title +
        '</span>' +
        '<a class="jy-atc-toast__cta" href="' +
        cartUrl +
        '">' +
        (isAr ? 'السلة' : 'Panier') +
        '</a>';
      void el.offsetWidth;
      el.classList.add('is-on');
      pulseCartBadge();
      if (toastTimer) clearTimeout(toastTimer);
      toastTimer = setTimeout(function () {
        el.classList.remove('is-on');
      }, 3600);
    }

    /* ---- Fast add-to-cart bottom sheet (CRO + AOV, non-blocking) ----
       Opens instantly after the single /cart/add round-trip. The free-ship
       progress and recommendations fill in asynchronously so they never
       delay the sheet appearing. */
    var sheetEl = null;
    var sheetHideTimer = null;
    function closeSheet() {
      if (!sheetEl) return;
      sheetEl.classList.remove('is-on');
      if (sheetHideTimer) clearTimeout(sheetHideTimer);
      sheetHideTimer = setTimeout(function () {
        if (sheetEl) sheetEl.setAttribute('hidden', '');
      }, 320);
    }
    function buildSheet() {
      var cartUrl = (window.FoxTheme && FoxTheme.routes && FoxTheme.routes.cart_url) || '/cart';
      var el = document.createElement('div');
      el.id = 'jy-atc-sheet';
      el.className = 'jy-atc-sheet';
      el.setAttribute('hidden', '');
      el.innerHTML =
        '<div class="jy-atc-sheet__scrim" data-atc-close></div>' +
        '<div class="jy-atc-sheet__panel" role="dialog" aria-label="' +
        (isAr ? 'أُضيف إلى السلة' : 'Ajouté au panier') +
        '"><span class="jy-atc-sheet__grip" aria-hidden="true"></span>' +
        '<div class="jy-atc-sheet__head"><span class="jy-atc-sheet__ok">' +
        '<span class="jy-atc-sheet__tick">✓</span>' +
        (isAr ? 'أُضيف المنتج إلى السلة!' : 'Produit ajouté au panier !') +
        '</span><a class="jy-atc-sheet__golink" href="' + cartUrl + '">' +
        (isAr ? 'اذهب للسلة ›' : 'Voir le panier ›') + '</a></div>' +
        '<div class="jy-atc-sheet__ship" data-atc-ship hidden></div>' +
        '<div class="jy-atc-sheet__reco" data-atc-reco hidden>' +
        '<div class="jy-atc-sheet__reco-head">' +
        (isAr ? 'ننصحك كمان بـ' : 'On vous recommande aussi') +
        '</div><div class="jy-atc-sheet__reco-row" data-jy-reco-row></div></div>' +
        '<div class="jy-atc-sheet__foot">' +
        '<button type="button" class="jy-atc-sheet__btn jy-atc-sheet__btn--ghost" data-atc-close>' +
        (isAr ? 'أكمل التسوق' : 'Continuer mes achats') + '</button>' +
        '<a class="jy-atc-sheet__btn jy-atc-sheet__btn--red" href="' + cartUrl + '">' +
        (isAr ? 'اذهب للسلة' : 'Voir le panier') + '</a></div></div>';
      document.body.appendChild(el);
      el.addEventListener('click', function (e) {
        if (e.target.closest('[data-atc-close]')) closeSheet();
      });
      return el;
    }
    function renderShip(cartTotalCents) {
      if (!sheetEl) return;
      var box = sheetEl.querySelector('[data-atc-ship]');
      var aov = window.JY_AOV || {};
      var thr = (aov.freeShip || 0) * 100;
      if (!box || !thr) return;
      var cur = productInfo.currency || 'Dhs';
      box.removeAttribute('hidden');
      if (cartTotalCents >= thr) {
        box.innerHTML =
          '<div class="jy-atc-sheet__ship-title jy-atc-sheet__ship-title--done">' +
          (isAr ? 'مبروك! التوصيل علينا 🎉' : 'Bravo ! Livraison offerte 🎉') +
          '</div><div class="jy-atc-sheet__bar"><span style="width:100%"></span></div>';
      } else {
        var remain = thr - cartTotalCents;
        var pct = Math.max(6, Math.round((cartTotalCents / thr) * 100));
        box.innerHTML =
          '<div class="jy-atc-sheet__ship-title">' +
          (isAr ? 'زوّد ' : 'Encore ') + '<b>' + fmt(remain) + ' ' + cur + '</b>' +
          (isAr ? ' والتوصيل علينا' : ' et la livraison est pour nous') +
          '</div><div class="jy-atc-sheet__bar"><span style="width:' + pct + '%"></span></div>';
      }
    }
    function loadSheetReco() {
      if (!sheetEl || !productInfo.id) return;
      var box = sheetEl.querySelector('[data-atc-reco]');
      var row = sheetEl.querySelector('[data-jy-reco-row]');
      if (!box || !row) return;
      fetch('/recommendations/products?section_id=jy-reco-cards&limit=10&intent=related&product_id=' +
        encodeURIComponent(productInfo.id))
        .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
        .then(function (text) {
          var fresh = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-jy-reco-row]');
          if (fresh && fresh.children.length) {
            row.innerHTML = fresh.innerHTML;
            box.removeAttribute('hidden');
          }
        })
        .catch(function () {});
    }
    function openSheet() {
      if (!sheetEl) sheetEl = buildSheet();
      loadSheetReco();
      sheetEl.removeAttribute('hidden');
      void sheetEl.offsetWidth;
      sheetEl.classList.add('is-on');
      pulseCartBadge();
    }

    function addToCart(submitter) {
      var mode = (submitter && submitter.dataset.jyCta) || 'cart';
      showError(false);
      setLoading(submitter, true);
      /* AddToCart is captured by the official apps' Web Pixel (product_added_to_cart) */

      /* mixed multi-piece bundle → add each piece as its own line, then send
         the shopper to the COD checkout page (which lists every item). The
         cart-level automatic discount handles the −10/−15% by piece count. */
      if (window.JY_BUNDLE && window.JY_BUNDLE.pieces && window.JY_BUNDLE.pieces.length > 1) {
        var bRoutes = (window.FoxTheme && FoxTheme.routes) || { cart_add_url: '/cart/add', cart_url: '/cart' };
        var bLines = window.JY_BUNDLE.pieces.map(function (p) {
          return { id: p.id, quantity: p.quantity, properties: { _jy_tier: 't' + window.JY_BUNDLE.tier } };
        });
        fetch(bRoutes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: bLines }),
        })
          .then(function (r) {
            return r.json();
          })
          .then(function () {
            var cartUrl = (bRoutes.cart_url || '/cart').replace(/\/+$/, '');
            window.location.href = cartUrl + '?view=checkout';
          })
          .catch(function () {
            setLoading(submitter, false);
            showError(isAr ? 'تعذّرت إضافة المنتجات، حاول مجدداً.' : "Impossible d'ajouter les articles, réessayez.");
          });
        return;
      }

      /* PERF: the blocking /cart/add stays MINIMAL — we deliberately do NOT send
         the `sections`/`sections_url` params. Those make Shopify render the heavy
         cart-drawer section server-side on the critical path, which was the main
         source of the button's "loading" delay. The badge + drawer are refreshed
         off the critical path (below), so the button responds as fast as the bare
         add-to-cart round-trip allows. */
      var fd = new FormData(form);

      var routes = (window.FoxTheme && FoxTheme.routes) || {
        cart_add_url: '/cart/add',
        cart_url: '/cart',
      };

      fetch(routes.cart_add_url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd,
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (parsedState) {
          if (parsedState.status) {
            showError(parsedState.description || parsedState.message || 'Erreur');
            document.dispatchEvent(
              new CustomEvent('product-ajax:error', { detail: { errorMessage: parsedState.description } })
            );
            return;
          }
          document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: parsedState } }));

          if (mode === 'express') {
            /* Express "Acheter maintenant" → straight to the custom COD
               checkout page (/cart?view=checkout), same flow the cart and
               bundle paths use. Keeps the highest-intent buyers on the
               COD-optimized checkout instead of native Shopify checkout.
               Item is already in the cart after /cart/add. */
            var exCartUrl = (routes.cart_url || '/cart').replace(/\/+$/, '');
            window.location.href = exCartUrl + '?view=checkout';
            return;
          }

          /* Open the CRO/AOV sheet INSTANTLY after the single /cart/add
             round-trip. Recommendations load async inside it; the badge and
             free-shipping progress are filled from the background cart fetch
             below — none of it blocks the sheet from appearing. */
          openSheet();

          /* OFF the critical path: refresh the header badge (item_count only —
             cart-count reads cart.item_count, no HTML needed) + the free-ship bar
             from a light /cart.js GET, and let the FoxTheme drawer re-render
             itself via cart:refresh (fetches its own section, not our concern). */
          var cartJsUrl = (routes.cart_url || '/cart').replace(/\/+$/, '') + '.js';
          fetch(cartJsUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
            .then(function (r) {
              return r.json();
            })
            .then(function (cartJson) {
              if (window.FoxTheme && FoxTheme.pubsub) {
                FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
              }
              renderShip(typeof cartJson.total_price === 'number' ? cartJson.total_price : 0);
            })
            .catch(function () {});
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        })
        .catch(function () {
          showError(isAr ? 'تعذّرت إضافة المنتج، حاول مجدداً.' : "Impossible d'ajouter le produit, réessayez.");
        })
        .finally(function () {
          setLoading(submitter, false);
        });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var submitter = e.submitter || root.querySelector('[data-jy-cta="cart"]');
        if (submitter && (submitter.disabled || submitter.getAttribute('aria-disabled') === 'true')) return;
        addToCart(submitter);
      });
    }

    /* ---------------- sticky buy bars ---------------- */
    var dbar = root.querySelector('[data-jy-dbuybar]');
    var ctaRow = root.querySelector('[data-jy-cta-row]');
    if (dbar && ctaRow && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            dbar.classList.toggle('show', past);
            dbar.setAttribute('aria-hidden', past ? 'false' : 'true');
          });
        },
        { threshold: 0 }
      );
      io.observe(ctaRow);
    }

    /* mobile buybar: if the bottom tab bar sets --jy-bottomnav-h, it owns the
       safe-area inset; avoid double padding. */
    var buybar = root.querySelector('[data-jy-buybar]');
    if (buybar) {
      var navH = getComputedStyle(document.documentElement).getPropertyValue('--jy-bottomnav-h').trim();
      if (navH && navH !== '0px' && navH !== '') buybar.classList.add('jy-buybar--abovenav');
    }

    /* ---------------- description "Lire la suite" clamp ---------------- */
    root.querySelectorAll('[data-jy-readmore]').forEach(function (wrap) {
      var content = wrap.querySelector('[data-jy-rm-content]');
      var toggle = wrap.querySelector('[data-jy-rm-toggle]');
      var label = wrap.querySelector('[data-jy-rm-label]');
      if (!content || !toggle) return;
      var moreTxt = label ? label.textContent : 'Lire la suite';
      var lessTxt = document.documentElement.lang === 'ar' ? 'عرض أقل' : 'Lire moins';
      var check = function () {
        // overflowing only matters while clamped
        if (content.classList.contains('jy-acc__body--open')) return;
        if (content.scrollHeight - content.clientHeight > 4) {
          toggle.hidden = false;
        } else {
          // short description: drop the clamp, no button
          content.classList.remove('jy-acc__body--clamp');
          toggle.hidden = true;
        }
      };
      check();
      window.addEventListener('load', check);
      toggle.addEventListener('click', function () {
        var open = content.classList.toggle('jy-acc__body--open');
        toggle.classList.toggle('jy-readmore--open', open);
        if (label) label.textContent = open ? lessTxt : moreTxt;
      });
    });

    /* ---------------- bundle "Complétez le look" ---------------- */
    var bundleEl = root.querySelector('[data-jy-bundle]');
    if (bundleEl) {
      (function (bundle) {
        var disc = parseFloat(bundle.getAttribute('data-disc')) || 0.9;
        var cur = bundle.getAttribute('data-cur') || '';
        var items = [].slice.call(bundle.querySelectorAll('[data-jy-bundle-item]'));
        var wasEl = bundle.querySelector('[data-jy-bundle-was]');
        var nowEl = bundle.querySelector('[data-jy-bundle-now]');
        var saveEl = bundle.querySelector('[data-jy-bundle-save]');
        var countEl = bundle.querySelector('[data-jy-bundle-count]');
        var addBtn = bundle.querySelector('[data-jy-bundle-add]');
        var saveLabel = (saveEl && saveEl.getAttribute('data-label')) || '';
        var dh = function (cents) {
          return Math.round(cents / 100);
        };
        function included(item) {
          if (item.hasAttribute('data-base')) return true;
          var cb = item.querySelector('[data-jy-bundle-cb]');
          return cb ? cb.checked : false;
        }
        function recompute() {
          var sum = 0;
          var count = 0;
          items.forEach(function (item) {
            if (included(item)) {
              sum += parseInt(item.getAttribute('data-price'), 10) || 0;
              count += 1;
            }
          });
          var now = Math.round(sum * disc);
          var save = sum - now;
          if (wasEl) wasEl.textContent = dh(sum) + ' ' + cur;
          if (nowEl) nowEl.textContent = dh(now) + ' ' + cur;
          if (saveEl) {
            var pct = Math.round((1 - disc) * 100);
            saveEl.textContent = '−' + pct + '% · ' + saveLabel + ' ' + dh(save) + ' ' + cur;
          }
          if (countEl) countEl.textContent = '(' + count + ')';
        }
        bundle.querySelectorAll('[data-jy-bundle-cb]').forEach(function (cb) {
          cb.addEventListener('change', function () {
            var lbl = cb.closest('[data-jy-bundle-item]');
            if (lbl) lbl.classList.toggle('on', cb.checked);
            recompute();
          });
        });
        recompute();

        if (addBtn) {
          addBtn.addEventListener('click', function () {
            var idInput = root.querySelector('[data-jy-id]');
            var lines = [];
            if (idInput && idInput.value) {
              lines.push({ id: parseInt(idInput.value, 10), quantity: 1, properties: { _jy_bundle: '1' } });
            }
            items.forEach(function (item) {
              if (item.hasAttribute('data-base')) return;
              if (!included(item)) return;
              var vid = parseInt(item.getAttribute('data-variant'), 10);
              if (vid) lines.push({ id: vid, quantity: 1, properties: { _jy_bundle: '1' } });
            });
            if (lines.length === 0) return;
            addBtn.classList.add('jy-loading');
            addBtn.disabled = true;
            var routes = (window.FoxTheme && FoxTheme.routes) || { cart_add_url: '/cart/add', cart_url: '/cart' };
            fetch(routes.cart_add_url + '.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: lines }),
            })
              .then(function (r) {
                return r.json();
              })
              .then(function () {
                return fetch(routes.cart_url + '.js', { headers: { Accept: 'application/json' } }).then(function (r) {
                  return r.json();
                });
              })
              .then(function (cartJson) {
                if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS) {
                  FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
                }
                /* the lot has several items → send the shopper straight to the
                   new COD checkout page (the custom form), not the old drawer */
                var cartUrl = (routes.cart_url || '/cart').replace(/\/+$/, '');
                window.location.href = cartUrl + '?view=checkout';
              })
              .catch(function () {
                addBtn.classList.remove('jy-loading');
                addBtn.disabled = false;
              });
          });
        }
      })(bundleEl);
    }

    /* ---------------- related products (recommendations API) ---------------- */
    /* The section now renders a relevance-first list server-side (curated
       suggestions → same brand → the product's own collections). Only hit the
       Shopify recommendations API when that came back empty — never overwrite
       relevant products with the algorithm's cross-category picks. */
    var related = root.querySelector('[data-jy-related]');
    var relatedGrid = related && related.querySelector('[data-jy-related-grid]');
    if (related && relatedGrid) {
      /* "Voir plus": reveal related products in batches (NOT infinite scroll —
         on a PDP that pulls shoppers away from the current product's CTA). */
      var relMoreBtn = related.querySelector('[data-jy-related-more]');
      var relStep = parseInt(related.dataset.jyRelatedShow, 10) || 10;
      var relVisible = relStep;
      var applyRelated = function () {
        var cards = relatedGrid.children;
        for (var i = 0; i < cards.length; i++) {
          cards[i].hidden = i >= relVisible;
        }
        if (relMoreBtn) relMoreBtn.hidden = cards.length <= relVisible;
      };
      if (relMoreBtn) {
        relMoreBtn.addEventListener('click', function () {
          relVisible += relStep;
          applyRelated();
        });
      }
      /* Liquid renders the list server-side; only hit the API when it's empty */
      if (related.dataset.url && relatedGrid.children.length === 0) {
        var loadRecos = function () {
          fetch(related.dataset.url)
            .then(function (r) {
              return r.text();
            })
            .then(function (text) {
              var doc = new DOMParser().parseFromString(text, 'text/html');
              var grid = doc.querySelector('[data-jy-related-grid]');
              if (grid && grid.children.length > 0) {
                relatedGrid.innerHTML = grid.innerHTML;
                applyRelated();
              } else if (relatedGrid.children.length === 0) {
                related.hidden = true;
              }
            })
            .catch(function () {
              if (relatedGrid.children.length === 0) related.hidden = true;
            });
        };
        if ('requestIdleCallback' in window) {
          requestIdleCallback(loadRecos, { timeout: 2000 });
        } else {
          setTimeout(loadRecos, 800);
        }
      }
      applyRelated();
    }
  }

  function boot() {
    document.querySelectorAll('[data-jy-pdp]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
